import $axios from 'axios'
import { Context } from '../index'

import {
  IS_LOGIN_EVENT_TYPE,
  AFTER_IS_LOGIN_EVENT_TYPE,
  LOGIN_EVENT_TYPE,
  AFTER_LOGIN_EVENT_TYPE,
  GET_USERINFO_EVENT_TYPE,
  AFTER_GET_USERINFO_EVENT_TYPE,
  RESPONSE_CODE,
  LOGGER_PREFIX
} from '../constants'

export default class UC {
  private context: Context

  constructor(context: Context) {
    this.context = context
    const { pm } = context

    if (pm) {
      this.addEventListener()
    }
  }

  public async login(options: LoginOptions): Promise<LoginRes> {
    const { fpId } = this.context
    // TODO 补充登录行为
    console.log(`[${LOGGER_PREFIX}] get login  options`, options)
    const data = {
      appId: options.appId ? options.appId : '',
      txnId: options.txnId ? options.txnId : '',
      fpId: fpId
    }

    return new Promise((resolve, reject) => {
      $axios
        .post('https://data.just4fun.sg/sb/tga/User/TPLogin', data)
        .then(res => {
          console.log('resresresres11', res)
          if (res.data.stateCode === 1) {
            const obj = {
              accessToken: res.data.resultInfo.accessToken,
              refreshToken: res.data.resultInfo.refreshToken,
              user: res.data.resultInfo.user
            }

            resolve(obj)
          }
        })
        .catch(err => {
          console.log('errerrerr', err)

          reject(err)
        })
    })
  }

  public getUserInfo(): Promise<UserInfo> {
    // TODO 补充获取用户信息形为
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return new Promise((resolve, reject) => {
      $axios.post('https://data.just4fun.sg/sb/tga/User/BaseInfo')
    })
  }

  private addEventListener() {
    const { pm } = this.context

    // 判断登录
    pm.on(IS_LOGIN_EVENT_TYPE, async () => {
      console.log(
        `[${LOGGER_PREFIX}] receive postmessage event '${IS_LOGIN_EVENT_TYPE}'`
      )
      pm.emit(AFTER_IS_LOGIN_EVENT_TYPE, {
        code: RESPONSE_CODE.SUCCESS,
        payload: true
      })
    })

    // 登录
    pm.on(LOGIN_EVENT_TYPE, async () => {
      console.log(
        `[${LOGGER_PREFIX}] receive postmessage event '${LOGIN_EVENT_TYPE}'`
      )

      // TODO 登录先直接获取用户信息，后续再对接app打开登录面板
      try {
        const userInfo = await this.getUserInfo()
        pm.emit(AFTER_LOGIN_EVENT_TYPE, {
          code: RESPONSE_CODE.SUCCESS,
          payload: userInfo
        })
      } catch (error) {
        pm.emit(AFTER_LOGIN_EVENT_TYPE, {
          code: RESPONSE_CODE.FAIL,
          error
        })
      }
    })

    // 获取用户信息
    pm.on(GET_USERINFO_EVENT_TYPE, async () => {
      console.log(
        `[${LOGGER_PREFIX}] receive postmessage event '${LOGIN_EVENT_TYPE}'`
      )
      try {
        const userInfo = await this.getUserInfo()
        pm.emit(AFTER_GET_USERINFO_EVENT_TYPE, {
          code: RESPONSE_CODE.SUCCESS,
          payload: userInfo
        })
      } catch (error) {
        pm.emit(AFTER_GET_USERINFO_EVENT_TYPE, {
          code: RESPONSE_CODE.FAIL,
          error
        })
      }
    })
  }
}
type UserInfo = ''

type LoginOptions = {
  appId?: string | number
  txnId: string | number
  fpId: string | number
}

type LoginRes = {
  accessToken?: string
  refreshToken?: string
}
